import { atom, useRecoilState } from "recoil";

interface BuildingSidebarState {
    isSidebarOpen: boolean;
    isCustomPlanSidebarOpen: boolean;
    currentCustomPlanDetails: {
        id: string;
        plan: any;
        name: string;
    } | null;
}

const measureSidebarStateAtom = atom<BuildingSidebarState>({
    key: "buildingSidebarState",
    default: {
        isSidebarOpen: false,
        isCustomPlanSidebarOpen: false,
        currentCustomPlanDetails: null,
    },
});

const useBuildingSidebarState = () => {
    const [state, setState] = useRecoilState(measureSidebarStateAtom);

    return {
        state,
        setState,
    };
};

export default useBuildingSidebarState;
